import React from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import ComparisonChartOptions from "components/Next/Dashboard/ComparisonChartOptions";
import * as nextReducer from "containers/Next/NextReducer";
const DataSettingsView = ({}) => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const comparisonOptions = useSelector((state) => nextReducer.getComparisonOptions(state, nextId));
    const comparisonChartOptions = useSelector((state) => nextReducer.getComparisonChartOptions(state, nextId));
    const updateComparisonChartOptions = (chartOptions) => dispatch(nextReducer.updateComparisonChartOptions(nextId, chartOptions));
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.simpleHeader, style: { marginBottom: "0px", marginRight: "14px" } }, "Data Settings"),
        React.createElement(ComparisonChartOptions, { id: nextId, comparisonOptions: comparisonOptions, comparisonChartOptions: comparisonChartOptions, updateComparisonChartOptions: updateComparisonChartOptions })));
};
export default DataSettingsView;
